import { render, staticRenderFns } from "./ClientAdd.vue?vue&type=template&id=481e8c06&"
import script from "./ClientAdd.vue?vue&type=script&lang=js&"
export * from "./ClientAdd.vue?vue&type=script&lang=js&"
import style0 from "./ClientAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports